module.exports = __webpack_public_path__ + "img/image3.2a476ea8.png";